// 用户相关API
import httpClient from '../http'
import { API_ENDPOINTS } from '../config'

export const userApi = {
  // 获取用户统计
  getStats: () => httpClient.get(API_ENDPOINTS.USER.STATS),

  // 获取用户卡密
  getCards: params => httpClient.get(API_ENDPOINTS.USER.CARDS, { params }),

  // 获取用户设备
  getDevices: params => httpClient.get(API_ENDPOINTS.USER.DEVICES, { params }),

  // 获取游戏记录
  getGameRecords: params => httpClient.get(API_ENDPOINTS.USER.GAME_RECORDS, { params }),

  // 获取余额变动记录
  getBalanceLogs: params => httpClient.get(API_ENDPOINTS.USER.BALANCE_LOGS, { params }),

  // 获取金币变动记录
  getCoinLogs: params => httpClient.get(API_ENDPOINTS.USER.COIN_LOGS, { params }),

  // 获取金币记录（用户APP数据）
  getCoinRecords: params => httpClient.get(API_ENDPOINTS.USER.COIN_RECORDS, { params }),

  // 获取应用列表
  getApps: params => httpClient.get(API_ENDPOINTS.USER.APPS, { params }),

  // 充值
  recharge: data => httpClient.post(API_ENDPOINTS.USER.RECHARGE, data),

  // 激活卡密
  activateCard: data => httpClient.post(API_ENDPOINTS.USER.ACTIVATE_CARD, data),

  // 获取APP统计数据
  getAppStats: params => httpClient.get(API_ENDPOINTS.USER.APP_STATS, { params }),

  // 获取设备APP统计数据
  getDeviceAppStats: params => httpClient.get(API_ENDPOINTS.USER.DEVICE_APP_STATS, { params }),

  // 获取用户设备列表（新的设备管理接口）
  getUserDevices: params => httpClient.get(API_ENDPOINTS.USER.DEVICES, { params }),

  // 获取设备详细信息
  getDeviceDetail: (deviceId, params) => httpClient.get(`${API_ENDPOINTS.USER.DEVICES}?device_id=${deviceId}`, { params }),

  // 解绑设备
  unbindDevice: (deviceId, cardCode) => httpClient.post('/api/user.html?action=unbind_device', {
    device_id: deviceId,
    card_code: cardCode
  }),

  // 更新设备备注
  updateDeviceRemark: data => httpClient.post(API_ENDPOINTS.USER_DEVICE.UPDATE_REMARK, data)
}
